import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, Col, Container, Row, Form, Button, Modal, Badge} from "react-bootstrap";
import {Link} from "react-router-dom";
import TableContainer from "Common/TableContainer";
import 'react-toastify/dist/ReactToastify.css';
import {DeleteModal} from "Common/DeleteModal";
import {
    getBannerSlider as onGetBannerSlider,
    addBannerSlider as onAddBannerSlider,
    updateBannerSlider as onUpdateBannerSlider,
    deleteBannerSlider as onDeleteBannerSlider
} from "slices/pages/bannerSlider/thunk";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {createSelector} from "reselect";
import {useFormik} from "formik";
import * as Yup from "yup";
import Dropzone from "react-dropzone";

const apiUrl = process.env.REACT_APP_API_URL;

const PLACEMENT_OPTIONS = [
    {value: "HERO", label: "Yuqori slayder"},
    {value: "SIDE", label: "Yon banner"},
    {value: "MIDDLE", label: "O'rta banner"},
];

const placementLabel = (value: string) =>
    PLACEMENT_OPTIONS.find((option) => option.value === value)?.label || value;

const BannerSlider = () => {

    document.title = "Bannerlar";
    const dispatch = useDispatch<any>();

    const selectBannerSlider = createSelector(
        (state: any) => state.BannerSlider,
        (bannerSlider) => ({
            bannerSliderList: bannerSlider.bannerSlider,
            loading: bannerSlider.loading,
        })
    );

    const {bannerSliderList, loading} = useSelector(selectBannerSlider);

    useEffect(() => {
        dispatch(onGetBannerSlider());
    }, [dispatch]);

    const [listView, setListView] = useState<any>();
    const [bannerSliderLists, setBannerSliders] = useState<any>(null);
    const [addBannerSlider, setAddBannerSlider] = useState<boolean>(false);
    const [editBannerSlider, setEditBannerSlider] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>();
    const [selectFile, setSelectFile] = useState<any>([]);
    const [selectFileMobile, setSelectFileMobile] = useState<any>([]);

    //add
    const handleCloseBannerSlider = () => {
        setAddBannerSlider(false);
        setSelectFile([]);
        setSelectFileMobile([]);
    }
    const handleShowBannerSlider = () => {
        setEdit(null);
        setEditBannerSlider(false);
        setAddBannerSlider(true);
    }
    //edit
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddBannerSlider(true);
        setEditBannerSlider(true);
        setEdit({
            id: lastItem.id,
            name: lastItem.name,
            link: lastItem.link,
            order: lastItem.order,
            placement: lastItem.placement,
            isActive: lastItem.isActive,
            pcImageUrl: lastItem.pcImageDto?.url ? apiUrl + lastItem.pcImageDto.url : null,
            mobImageUrl: lastItem.mobImageDto?.url ? apiUrl + lastItem.mobImageDto.url : null,
        });
        setSelectFile([]);
        setSelectFileMobile([]);
    }, []);

    //search
    const handleChange = (ele: any) => {
        let search = ele.target.value;
        if (search) {
            setListView(bannerSliderList.content?.filter((item: any) => item.name?.toLowerCase().includes(search.toLowerCase())));
        } else {
            setListView(bannerSliderList.content);
        }
    };

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setBannerSliders(ele);
    };

    const handleDeleteClose = () => {
        setShow(false);
    }

    //delete modal
    const deleteModalFunction = () => {
        const deleteData = bannerSliderLists.row.original.id || {};
        if (deleteData) {
            dispatch(onDeleteBannerSlider(deleteData));
        }
        setShow(false);
    };

    useEffect(() => {
        setListView(bannerSliderList?.content);
    }, [bannerSliderList]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Rasm (desktop)",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    const src = cell.row.original.pcImageDto?.url;
                    return (
                        <div className={""}>
                            {src ? <img src={apiUrl + src} alt={""} className={"category_img"}/> : null}
                        </div>
                    )
                }
            },
            {
                header: "Nomi",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Joylashuv",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => (
                    <Badge bg="secondary-subtle" text="secondary">
                        {placementLabel(cell.row.original.placement)}
                    </Badge>
                ),
            },
            {
                header: "Tartib",
                accessorKey: "order",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Holat",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => (
                    cell.row.original.isActive ? (
                        <Badge bg="success-subtle" text="success">Faol</Badge>
                    ) : (
                        <Badge bg="danger-subtle" text="danger">Nofaol</Badge>
                    )
                ),
            },
            {
                header: "Yaratilgan",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Amallar",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell)}><i className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );

    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (edit && edit.name) || '',
            id: edit && edit.id,
            link: (edit && edit.link) || '',
            order: edit && edit.order,
            placement: (edit && edit.placement) || '',
            isActive: edit ? !!edit.isActive : true,
            pcImage: null,
            mobImage: null,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Banner nomini kiriting"),
            link: Yup.string().required("Havolani kiriting"),
            order: Yup.number().typeError("Tartib raqam bo'lishi kerak").required("Tartibni kiriting"),
            placement: Yup.string().required("Joylashuvni tanlang"),
            pcImage: editBannerSlider ? Yup.mixed().notRequired() : Yup.mixed().required("Desktop rasmni yuklang"),
            mobImage: editBannerSlider ? Yup.mixed().notRequired() : Yup.mixed().required("Mobil rasmni yuklang"),
        }),

        onSubmit: (values: any) => {

            const data: any = {
                name: values.name,
                link: values.link,
                order: Number(values.order),
                placement: values.placement,
                isActive: values.isActive,
            }

            const formData = new FormData();
            formData.append('bannerDto', new Blob([JSON.stringify(data)], {type: 'application/json'}));
            if (values.pcImage) {
                formData.append('pcImage', values.pcImage);
            }
            if (values.mobImage) {
                formData.append('mobImage', values.mobImage);
            }

            if (editBannerSlider) {
                dispatch(onUpdateBannerSlider({updateFormData: formData, id: values.id}));
            } else {
                dispatch(onAddBannerSlider(formData));
            }

            formik.resetForm();
            setEdit(null);
            setEditBannerSlider(false);
            handleCloseBannerSlider();
        }
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row id="bannerSliderList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Bannerlar</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Banner qidirish..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button variant="secondary" onClick={handleShowBannerSlider}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Banner
                                                    qo'shish
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {
                                        listView && listView.length > 0 ?
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView || []}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                            :
                                            <div id="noresult">
                                                <div className="text-center py-4">
                                                    <div className="avatar-md mx-auto mb-4">
                                                        <div
                                                            className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                            <i className="bi bi-search"></i>
                                                        </div>
                                                    </div>
                                                    <h5 className="mt-2">
                                                        {loading ? "Yuklanmoqda..." : "Hech narsa topilmadi"}
                                                    </h5>
                                                </div>
                                            </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addBannerSlider} onHide={handleCloseBannerSlider}>
                <Modal.Header closeButton>
                    <Modal.Title>{editBannerSlider ? "Bannerni tahrirlash" : "Banner qo'shish"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-3">
                            <Form.Label htmlFor="bannerSliderName">Banner nomi<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="bannerSliderName"
                                name="name"
                                placeholder="Nomi"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.name}
                            />
                            {formik.errors.name && formik.touched.name ? (
                                <Form.Control.Feedback
                                    type="invalid">{formik.errors.name}</Form.Control.Feedback>
                            ) : null}
                        </div>
                        <Row className="mb-3">
                            <Col lg={6}>
                                <div className="mb-3">
                                    <Form.Label htmlFor="bannerSliderLink">Havola<span
                                        className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="bannerSliderLink"
                                        name="link"
                                        placeholder="/search yoki /category/..."
                                        value={formik.values.link}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.link}
                                    />
                                    {formik.errors.link && formik.touched.link ? (
                                        <Form.Control.Feedback
                                            type="invalid">{formik.errors.link}</Form.Control.Feedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3">
                                    <Form.Label htmlFor="bannerSliderOrder">Tartib<span
                                        className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        id="bannerSliderOrder"
                                        name="order"
                                        placeholder="1"
                                        value={formik.values.order}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.order}
                                    />
                                    {formik.errors.order && formik.touched.order ? (
                                        <Form.Control.Feedback
                                            type="invalid">{formik.errors.order}</Form.Control.Feedback>
                                    ) : null}
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <div className="mb-3">
                                    <Form.Label htmlFor="bannerSliderPlacement">Joylashuv<span
                                        className="text-danger">*</span></Form.Label>
                                    <Form.Select
                                        id="bannerSliderPlacement"
                                        name="placement"
                                        value={formik.values.placement}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.placement}
                                    >
                                        <option value="">Tanlang...</option>
                                        {PLACEMENT_OPTIONS.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </Form.Select>
                                    {formik.errors.placement && formik.touched.placement ? (
                                        <Form.Control.Feedback
                                            type="invalid" className="d-block">{formik.errors.placement}</Form.Control.Feedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col lg={6} className="d-flex align-items-center">
                                <Form.Check
                                    type="checkbox"
                                    id="bannerSliderActive"
                                    name="isActive"
                                    label="Faol (saytda ko'rinsin)"
                                    checked={formik.values.isActive}
                                    onChange={formik.handleChange}
                                />
                            </Col>
                        </Row>

                        <div className="mb-3">
                            <Dropzone
                                onDrop={(acceptedFiles: File[]) => {
                                    if (acceptedFiles.length > 0) {
                                        formik.setFieldValue("pcImage", acceptedFiles[0]);
                                        setSelectFile(acceptedFiles)
                                    }
                                }}
                                multiple={false}
                                accept={{"image/*": []}}
                            >
                                {(dropzoneProps: any) => {
                                    const {getRootProps, getInputProps} = dropzoneProps;
                                    return (
                                        <div className="mb-3">
                                            <Form.Label htmlFor="banner-pc-image-input">Desktop rasm{!editBannerSlider &&
                                                <span className="text-danger">*</span>}</Form.Label>
                                            <div
                                                {...getRootProps()}
                                                className="dropzone my-dropzone border border-1 border-dashed text-center dz-clickable"
                                                style={{minHeight: "100px"}}
                                            >
                                                <input {...getInputProps()} name="pcImage"
                                                       onBlur={formik.handleBlur}/>
                                                <div className="dz-message needsclick py-3">
                                                    <i className="bi bi-cloud-download fs-1 mb-2"/>
                                                    <h5>Faylni shu yerga tashlang yoki bosing.</h5>
                                                </div>
                                            </div>
                                            {formik.errors.pcImage && formik.touched.pcImage && (
                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                    {formik.errors.pcImage}
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    );
                                }}
                            </Dropzone>

                            {selectFile?.length === 0 && edit?.pcImageUrl && (
                                <div className="mb-3">
                                    <img src={edit.pcImageUrl} alt="" className="category_img"/>
                                </div>
                            )}

                            <ul className="list-unstyled mb-3" id="dropzone-preview">
                                {selectFile?.map((file: any, index: any) => (
                                    <li className="mt-2 dz-image-preview" key={index}>
                                        <div className="border rounded">
                                            <div className="d-flex flex-wrap gap-2 p-2">
                                                <div className="flex-shrink-0 me-3">
                                                    <div className="avatar-sm bg-light rounded p-2">
                                                        <img data-dz-thumbnail=""
                                                             className="img-fluid rounded d-block"
                                                             src={URL.createObjectURL(file)}
                                                             alt={file?.name}/>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="pt-1">
                                                        <h5 className="fs-md mb-1">{file.name}</h5>
                                                        <p className="fs-sm text-muted mb-0">
                                                            {(file.size / 1024).toFixed(2)} KB
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex-shrink-0 ms-3">
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => {
                                                            setSelectFile([]);
                                                            formik.setFieldValue("pcImage", null);
                                                        }}
                                                    >
                                                        O'chirish
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="mb-3">
                            <Dropzone
                                onDrop={(acceptedFiles: File[]) => {
                                    if (acceptedFiles.length > 0) {
                                        formik.setFieldValue("mobImage", acceptedFiles[0]);
                                        setSelectFileMobile(acceptedFiles)
                                    }
                                }}
                                multiple={false}
                                accept={{"image/*": []}}
                            >
                                {(dropzoneProps: any) => {
                                    const {getRootProps, getInputProps} = dropzoneProps;
                                    return (
                                        <div className="mb-3">
                                            <Form.Label htmlFor="banner-mob-image-input">Mobil rasm{!editBannerSlider &&
                                                <span className="text-danger">*</span>}</Form.Label>
                                            <div
                                                {...getRootProps()}
                                                className="dropzone my-dropzone border border-1 border-dashed text-center dz-clickable"
                                                style={{minHeight: "100px"}}
                                            >
                                                <input {...getInputProps()} name="mobImage"
                                                       onBlur={formik.handleBlur}/>
                                                <div className="dz-message needsclick py-3">
                                                    <i className="bi bi-cloud-download fs-1 mb-2"/>
                                                    <h5>Faylni shu yerga tashlang yoki bosing.</h5>
                                                </div>
                                            </div>
                                            {formik.errors.mobImage && formik.touched.mobImage && (
                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                    {formik.errors.mobImage}
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    );
                                }}
                            </Dropzone>

                            {selectFileMobile?.length === 0 && edit?.mobImageUrl && (
                                <div className="mb-3">
                                    <img src={edit.mobImageUrl} alt="" className="category_img"/>
                                </div>
                            )}

                            <ul className="list-unstyled mb-3" id="dropzone-preview">
                                {selectFileMobile?.map((file: any, index: any) => (
                                    <li className="mt-2 dz-image-preview" key={index}>
                                        <div className="border rounded">
                                            <div className="d-flex flex-wrap gap-2 p-2">
                                                <div className="flex-shrink-0 me-3">
                                                    <div className="avatar-sm bg-light rounded p-2">
                                                        <img data-dz-thumbnail=""
                                                             className="img-fluid rounded d-block"
                                                             src={URL.createObjectURL(file)}
                                                             alt={file?.name}/>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="pt-1">
                                                        <h5 className="fs-md mb-1">{file.name}</h5>
                                                        <p className="fs-sm text-muted mb-0">
                                                            {(file.size / 1024).toFixed(2)} KB
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex-shrink-0 ms-3">
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => {
                                                            setSelectFileMobile([]);
                                                            formik.setFieldValue("mobImage", null);
                                                        }}
                                                    >
                                                        O'chirish
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseBannerSlider}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Yopish
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                            id="add-btn"
                        >
                            {editBannerSlider ? "Yangilash" : "Qo'shish"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default BannerSlider;
